module.exports = __webpack_public_path__ + "img/swiper-18.d70b23de.png";